module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/ClarkDeco-fed8793343115ee77c13ce2f1945392e.png";